module.exports = __webpack_public_path__ + "img/icon-warning-thunder-3.58a63e79.svg";